import React, { FC, useEffect, useRef } from "react";

import { Player } from "./components";
import * as Styled from "./styles";

type TBottomPlayer = {
  handleCloseTrack: () => void;
  isTrackActive: boolean;
  /** Curated-playlist mode: strips the download + heart actions. */
  curated?: boolean;
};

export const BottomPlayer: FC<TBottomPlayer> = ({ handleCloseTrack, isTrackActive, curated }) => {
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let observer: IntersectionObserver | null = null;
    let retryTimeout: ReturnType<typeof setTimeout> | null = null;

    const setup = () => {
      const footer = document.querySelector("[data-footer]") as HTMLElement;
      if (!footer) {
        retryTimeout = setTimeout(setup, 500);
        return;
      }

      observer = new IntersectionObserver(
        ([entry]) => {
          const player = playerRef.current;
          if (!player) return;
          if (entry.isIntersecting) {
            player.style.transform = "translateY(100%)";
            player.style.opacity = "0";
            player.style.pointerEvents = "none";
          } else {
            player.style.transform = "translateY(0)";
            player.style.opacity = "1";
            player.style.pointerEvents = "auto";
          }
        },
        { threshold: 0, rootMargin: "0px 0px 100px 0px" },
      );

      observer.observe(footer);
    };

    setup();

    return () => {
      if (retryTimeout) clearTimeout(retryTimeout);
      observer?.disconnect();
    };
  }, []);

  // The bottom player is track-only; the cart lives in the header.
  if (!isTrackActive) return null;

  return (
    <Styled.BottomPlayer ref={playerRef}>
      <Styled.PlayerRow>
        <Player handleCloseTrack={handleCloseTrack} curated={curated} />
      </Styled.PlayerRow>
    </Styled.BottomPlayer>
  );
};
